import {DISPOSAL_METHOD_LABELS, DisposalIntent, INTENT_OPTIONS} from './itemLifecycle';

/**
 * Определения способов выбытия — единственное место, где написано, чем они отличаются.
 *
 * <p>В аудите четыре способа стояли рядом без пояснений, и разница между «Отдать» и
 * «Пожертвовать» существовала только в голове автора. Способ влияет на аналитику и
 * экологическую статистику, поэтому выбирать его вслепую нельзя.</p>
 *
 * <p>Один справочник на три экрана — кандидатов, «Ждут передачи» и диалог подтверждения:
 * иначе определения разойдутся ровно так же, как разошлись названия стадий.</p>
 */
export const DISPOSAL_METHOD_HINTS: Record<DisposalIntent, string> = {
    GIVEN_AWAY: 'конкретному человеку',
    DONATED: 'организации: фонду, приюту, пункту приёма вещей',
    RECYCLED: 'в сбор текстиля — вещь получает вторую жизнь как сырьё',
    DISPOSED: 'в бытовые отходы',
};

/** Способ выбытия для карточки выбора: подпись действия плюс определение. */
export interface DisposalMethodOption {
    value: DisposalIntent;
    /** «Отдать», «Пожертвовать» — подпись кнопки подтверждения. */
    label: string;
    /** Подпись намерения; совпадает с {@link label} после перехода на инфинитив. */
    intentLabel: string;
    hint: string;
}

/** Порядок тот же, что у намерений: сначала то, что даёт вещи вторую жизнь, свалка — последней. */
export const DISPOSAL_METHOD_OPTIONS: DisposalMethodOption[] = INTENT_OPTIONS.map(o => ({
    value: o.value,
    label: DISPOSAL_METHOD_LABELS[o.value],
    intentLabel: o.label,
    hint: DISPOSAL_METHOD_HINTS[o.value],
}));

export function disposalMethodHint(intent: DisposalIntent | null | undefined): string | null {
    return intent ? DISPOSAL_METHOD_HINTS[intent] ?? null : null;
}
